let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("TR24h")).then(() => parcelRequire('bYpqK'));